import React from 'react';
import { Table, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnType } from 'antd/es/table';
import type { FilterDropdownProps } from 'antd/lib/table/interface';
import type { Key } from 'react';

interface DataTableProps {
  title?: string;
  data: any[];
  columns: ColumnType<any>[];
  loading?: boolean;
}

const DataTable: React.FC<DataTableProps> = ({ title, data, columns, loading }) => {
  const getColumnSearchProps = (dataIndex: string): Partial<ColumnType<any>> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: FilterDropdownProps) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <button
            type="button"
            onClick={() => confirm()}
            style={{ width: 90 }}
          >
            Search
          </button>
          <button
            onClick={() => {
              clearFilters?.();
              confirm?.();
            }}
            style={{ width: 90 }}
          >
            Reset
          </button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value: boolean | Key, record: any) => {
      const val = String(value).toLowerCase();
      const fieldValue = record[dataIndex]?.toString().toLowerCase() ?? '';
      return fieldValue.includes(val);
    }
  });

  const enhancedColumns: ColumnType<any>[] = columns.map(column => ({
    ...column,
    ...getColumnSearchProps(column.dataIndex as string),
  }));

  return (
    <Table
      columns={enhancedColumns}
      dataSource={data}
      loading={loading}
      title={title ? () => title : undefined}
      pagination={{
        defaultPageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      }}
    />
  );
};

export default DataTable;
